import { c as _c } from "react/compiler-runtime";
import { teamDisplayProperties } from "@components/table/teams/teams-table-utils";
import { PALETTE_VARS } from "@styles/palette-vars";
import { Text, Tooltip } from "@flat-ui";
import { Box, Stack } from "@mui-wrapper";
/**
 * Renders a category chip for a team, with optional label text and tooltip.
 *
 * - If `shouldShowText` is provided, the chip shows text in uppercase and pill-shaped.
 * - If `shouldShowText` is not provided, a small colored circle is shown instead.
 * - On hover, a tooltip provides information about the team category.
 */
export function TeamCategoryChipIcon(t0) {
  const $ = _c(22);
  const {
    kind,
    shouldShowText: t1
  } = t0;
  const shouldShowText = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      gap: "0.5rem",
      padding: "0.375rem 0.75rem"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = teamDisplayProperties[kind];
  let t4;
  if ($[1] !== t3.label) {
    t4 = <Text variant="bodyS" color={PALETTE_VARS.common.white}>{t3.label}</Text>;
    $[1] = t3.label;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = teamDisplayProperties[kind];
  let t6;
  if ($[3] !== t5.description) {
    t6 = <Text variant="bodyS" color={PALETTE_VARS.common.white}>{t5.description}</Text>;
    $[3] = t5.description;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t4 || $[6] !== t6) {
    t7 = <Stack sx={t2}>{t4}{t6}</Stack>;
    $[5] = t4;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const t8 = shouldShowText ? "1rem" : "50%";
  const t9 = `1px solid ${teamDisplayProperties[kind].chipProps?.border}`;
  const t10 = teamDisplayProperties[kind].chipProps?.background;
  const t11 = shouldShowText ? 0 : "1rem";
  let t12;
  if ($[8] !== t10 || $[9] !== t11 || $[10] !== t8 || $[11] !== t9) {
    t12 = {
      height: "1.5rem",
      width: "fit-content",
      borderRadius: t8,
      display: "flex",
      alignItems: "center",
      border: t9,
      backgroundColor: t10,
      marginRight: t11,
      padding: "0 0.5rem"
    };
    $[8] = t10;
    $[9] = t11;
    $[10] = t8;
    $[11] = t9;
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] !== kind || $[14] !== shouldShowText) {
    t13 = shouldShowText ? <Text variant="labelS" color={teamDisplayProperties[kind].chipProps?.icon} textTransform="uppercase">{teamDisplayProperties[kind].label}</Text> : <Box data-testid="CircleIcon" sx={{
      backgroundColor: teamDisplayProperties[kind].chipProps?.icon,
      width: "0.5rem",
      height: "0.5rem",
      borderRadius: "0.25rem"
    }} />;
    $[13] = kind;
    $[14] = shouldShowText;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t12 || $[17] !== t13) {
    t14 = <Box sx={t12}>{t13}</Box>;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] !== t14 || $[20] !== t7) {
    t15 = <Tooltip component="div" title={t7} enterDelay={300} enterNextDelay={300}>{t14}</Tooltip>;
    $[19] = t14;
    $[20] = t7;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  return t15;
}